jQuery(document).ready(function () {
  var deliveryDateType = "weekday";

  function resetDeliveryTime(deliveryDateType) {
    document.querySelector("#cart-delivery-time-input").selectedIndex = 0;
    let weekdayOptions = document.getElementsByClassName(
      "delivery-time-weekday"
    );
    let weekendOptions = document.getElementsByClassName(
      "delivery-time-weekend"
    );
    if (deliveryDateType === "weekend") {
      weekdayOptions.forEach((weekdayOption) => {
        weekdayOption.style.display = "none";
      });
      weekendOptions.forEach((weekendOption) => {
        weekendOption.style.display = "block";
      });
    } else {
      weekdayOptions.forEach((weekdayOption) => {
        weekdayOption.style.display = "block";
      });
      weekendOptions.forEach((weekendOption) => {
        weekendOption.style.display = "none";
      });
    }
  }

  function updateDeliveryDate(event) {
    jQuery.post("/cart/update.js", {
      attributes: {
        "delivery-date": event.target.value,
      },
    });
    var myDate = new Date(event.target.value.concat("T00:00"));
    if (myDate.getDay() == 6 || myDate.getDay() == 0) {
      deliveryDateType = "weekend";
    } else {
      deliveryDateType = "weekday";
    }
    resetDeliveryTime(deliveryDateType);
  }

  function updateDeliveryTime(event) {
    jQuery.post("/cart/update.js", {
      attributes: {
        "delivery-time": event.target.value,
      },
    });
  }

  let currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + 1);
  let currentDay = currentDate.getDate();
  let currentMonth = currentDate.getMonth() + 1;
  let currentYear = currentDate.getFullYear();
  const pMonth = currentMonth.toString().padStart(2, "0");
  const pDay = currentDay.toString().padStart(2, "0");
  const newPaddedDate = `${currentYear}-${pMonth}-${pDay}`;
  dateInput = document.querySelector("#cart-delivery-date-input");
  dateInput.setAttribute("min", newPaddedDate);
  document
    .querySelector("#cart-delivery-date-input")
    .addEventListener("change", updateDeliveryDate);
  document
    .querySelector("#cart-delivery-time-input")
    .addEventListener("change", updateDeliveryTime);

  function isIE() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ");
    const trident = ua.indexOf("Trident/");

    return msie > 0 || trident > 0;
  }

  if (!isIE()) return;
  const cartSubmitInput = document.createElement("input");
  cartSubmitInput.setAttribute("name", "checkout");
  cartSubmitInput.setAttribute("type", "hidden");
  document.querySelector("#cart").appendChild(cartSubmitInput);
  document
    .querySelector("#checkout")
    .addEventListener("click", function (event) {
      document.querySelector("#cart").submit();
    });
});
